
import { Component, Vue, Prop } from 'vue-property-decorator'
import StatusDot from '@/components/status_dot/index.vue'

@Component({
    name: 'pr-table',
    components: {
        StatusDot
    }
})
export default class CompanyTable extends Vue {
    @Prop({ required: true }) private value!: any[]

    private onGoDetail(pr: any) {
        const href = `/enterprise/pr/${pr.id}` 
        window.open(href, '_blank')
    }
}
